import React from 'react';
import '../style/LetsWorkSection.scss';
import { Link } from "react-router-dom";

const LetsWorkSection = () => {
  return (
    <section className="lets-work">
      <h2>Let’s Work</h2>
      <p>
        Let’s Work Together To Create Something Amazing. Click The Button Below To Get In Touch
        <br />
        And Start Your Journey With Quasart Today.
      </p>
      <Link to="/contact"className="btn-contact" >
      Contact Us
      </Link>
    </section>
  );
};

export default LetsWorkSection;
